/* eslint-disable import/prefer-default-export */
/**
 * * Adapted from the original function in the PDP Backbone code
 * @see {@link src/js/util/ViewState/NewPickupMessaging.js}
 * @param {Object} options
 * @param {boolean} [options.inStorePickupEligibility]
 * @param {boolean} [options.curbsidePickupEligibility]
 * @param {string} options.deliveryDay
 * @param {string} [options.otherDate]
 * @param {any[]} [options.pickupOptions] - TODO contract is not clear
 * @param {PickupTime} options.curbsideCutOffTime
 * @param {PickupTime} options.cutOffTime
 * @param {ATBBopsAvailability} options.availability
 */
export const bopsPickupMessagging = ({
  inStorePickupEligibility = false,
  curbsidePickupEligibility = false,
  deliveryDay,
  otherDate,
  pickupOptions = [],
  curbsideCutOffTime,
  cutOffTime,
  availability,
}) => {
  const bopsLinkTagMessage = ['In Store:', 'NA', '-', 'Curbside:', 'NA'];// 1st and 4th index are dynamic part of tagging message
  const deliveryDayLower = deliveryDay ? deliveryDay.toLowerCase() : '';
  if (pickupOptions && pickupOptions.length > 1 && otherDate) {
    const curbSideAvailableDay = curbsideCutOffTime.pickupRelativeDay.toLowerCase();
    const inStoreAvailableDay = cutOffTime.pickupRelativeDay.toLowerCase();

    if (pickupOptions[0].toLowerCase() === 'in store') {
      bopsLinkTagMessage[1] = (deliveryDayLower === 'today' || deliveryDayLower === 'tomorrow') ? deliveryDay : 'OTHER';
      bopsLinkTagMessage[4] = curbSideAvailableDay ? curbSideAvailableDay.toUpperCase() : 'NA';// pass NA if value coming in undefined
    } else {
      bopsLinkTagMessage[1] = inStoreAvailableDay ? inStoreAvailableDay.toUpperCase() : 'NA';
      bopsLinkTagMessage[4] = (deliveryDayLower === 'today' || deliveryDayLower === 'tomorrow') ? deliveryDay : 'OTHER';
    }
  } else if (pickupOptions && pickupOptions.length > 1) {
    // Both In Store and Curbside pickup are enabled - available same day
    const tagDeliveryDay = (deliveryDayLower === 'today' || deliveryDayLower === 'tomorrow') ? deliveryDay : 'OTHER';
    bopsLinkTagMessage[1] = tagDeliveryDay;
    bopsLinkTagMessage[4] = tagDeliveryDay;
  } else if (pickupOptions) {
    if (pickupOptions[0] && (pickupOptions[0].toLowerCase() === 'in store')) { // only instore available
      bopsLinkTagMessage[1] = (deliveryDayLower === 'today' || deliveryDayLower === 'tomorrow') ? deliveryDay : 'OTHER';
    } else { // only curbside available
      bopsLinkTagMessage[4] = (deliveryDayLower === 'today' || deliveryDayLower === 'tomorrow') ? deliveryDay : 'OTHER';
    }
  }
  const { bopsAvailable } = availability;
  bopsLinkTagMessage[1] = inStorePickupEligibility ? bopsLinkTagMessage[1] : 'NA';
  bopsLinkTagMessage[4] = curbsidePickupEligibility ? bopsLinkTagMessage[4] : 'NA';
  const bopsLinkTagMessageResult = bopsAvailable ? bopsLinkTagMessage.join('') : undefined;

  return bopsLinkTagMessageResult;
};
